var Environment;
(function(Environment2) {
  Environment2["PRODUCTION"] = "production";
  Environment2["STAGING"] = "staging";
  Environment2["DEVELOPMENT"] = "development";
})(Environment || (Environment = {}));

export { Environment };
